import React from "react";
import { Link } from "react-router-dom";
import { pricing, removalPricing } from "../mock";
import { CheckCircle2 } from "lucide-react";
import { Button } from "../components/ui/button";

export default function PricingPage() {
  return (
    <>
      <section className="bg-gradient-to-b from-slate-50 to-white py-16 md:py-20 border-b border-slate-100">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 text-center">
          <div className="text-xs uppercase tracking-[0.2em] text-slate-500 mb-3">Pricing</div>
          <h1 className="text-4xl md:text-5xl font-bold text-[#0B2447] tracking-tight">Simple plans. Transparent removals.</h1>
          <p className="mt-4 text-lg text-slate-600 max-w-2xl mx-auto">Ongoing reputation plans for teams that want peace of mind. Plus pay-per-result pricing for content removal.</p>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 md:grid-cols-3 gap-6">
          {pricing.map((p) => (
            <div key={p.name} className={`rounded-2xl p-8 border ${p.popular ? "border-[#0B2447] bg-white shadow-xl scale-[1.02]" : "border-slate-200 bg-white"}`}>
              {p.popular && <div className="inline-block text-xs font-semibold bg-[#0B2447] text-white px-2.5 py-1 rounded-full mb-3">Most popular</div>}
              <h3 className="text-xl font-bold text-[#0B2447]">{p.name}</h3>
              <div className="mt-3 flex items-baseline gap-1">
                <span className="text-4xl font-bold text-[#0B2447]">{p.price}</span>
                <span className="text-slate-500">{p.period}</span>
              </div>
              <p className="mt-3 text-sm text-slate-600">{p.desc}</p>
              <ul className="mt-6 space-y-3">
                {p.features.map((f) => (
                  <li key={f} className="flex items-start gap-2 text-sm text-slate-700"><CheckCircle2 className="w-4 h-4 text-emerald-500 mt-0.5 shrink-0" /> {f}</li>
                ))}
              </ul>
              <Link to="/contact" className="block mt-8">
                <Button className={`w-full h-11 ${p.popular ? "bg-[#0B2447] hover:bg-[#122e5f] text-white" : "bg-slate-100 text-[#0B2447] hover:bg-slate-200"}`}>{p.cta}</Button>
              </Link>
            </div>
          ))}
        </div>
      </section>

      <section className="py-16 bg-slate-50">
        <div className="max-w-5xl mx-auto px-6 lg:px-10">
          <div className="text-center mb-10">
            <div className="text-xs uppercase tracking-[0.2em] text-slate-500 mb-3">Content removal</div>
            <h2 className="text-3xl md:text-4xl font-bold text-[#0B2447] tracking-tight">{removalPricing.headline}</h2>
            <p className="mt-3 text-slate-600">{removalPricing.sub}</p>
          </div>
          <div className="rounded-2xl border border-slate-200 bg-white overflow-hidden">
            <table className="w-full text-sm">
              <thead className="bg-slate-100 text-slate-600">
                <tr>
                  <th className="text-left px-6 py-3 font-semibold">Platform</th>
                  <th className="text-right px-6 py-3 font-semibold">Price per removal</th>
                </tr>
              </thead>
              <tbody>
                {removalPricing.rows.map((r) => (
                  <tr key={r.platform} className="border-t border-slate-100">
                    <td className="px-6 py-4 text-[#0B2447] font-medium">{r.platform}</td>
                    <td className="px-6 py-4 text-right text-slate-700">{r.price}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <p className="text-xs text-slate-500 text-center mt-4">You only pay when the content is successfully removed. Final quote provided after a free assessment.</p>
        </div>
      </section>
    </>
  );
}
